// Implements: F-MCK-003, F-MCK-018, F-UIX-009, F-UIX-010
/**
 * One mockup, under the SHARED key `["mockups","detail",id]`.
 *
 * The version tree reads the same query for its current pointer, so the page
 * makes one request and a scope change refreshes both.
 */

import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { fetchMockupDetail } from "../../../shared/api/mockupDetail";
import { mockupDetailKey } from "../../../shared/api/queryKeys";
import type { MockupDetailView } from "../../../types/api";

export type UseMockupDetailResult = UseQueryResult<MockupDetailView, ApiError>;

export function useMockupDetail(mockupId: string): UseMockupDetailResult {
  return useQuery<MockupDetailView, ApiError>({
    queryKey: mockupDetailKey(mockupId),
    queryFn: () => fetchMockupDetail(mockupId),
  });
}
